<template>
  <div>
    <div
      v-bind:class="{ active: viewBlack }"
      @click="activeHamburger()"
      class="view_black"
    ></div>
    <header class="custom">
      <div class="header_left">
        <!-- <MenuMovil class="small__show" /> -->
        <v-btn class="menu_hamburger" @click="activeHamburger()" icon text>
          <v-icon>mdi-menu</v-icon>
        </v-btn>

        <v-btn class="logo" to="/" text>
          <img alt src="img/icons/logo_v3_white.svg" />
        </v-btn>
      </div>
      <div v-bind:class="{ active: flat_menu }" class="sider-mobile">
        <!-- <p>
          valor --login
          {{ isLogin }}
        </p> -->
        <div class="btn__close">
          <v-btn icon @click="closeHamburger()" color="black">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <ul class="menu__left">
          <!-- <li>
            <v-btn text class="mnu_hd login_btn" to="signin" v-if="!isLogin"
              >INCIAR SESIÓN</v-btn
            >
          </li>
          <li>
            <v-btn class="mnu_hd register" text to="signup" v-if="!isLogin"
              >COMENZAR</v-btn
            >
          </li> -->
          <li>
            <v-btn
              class="mnu_hd register"
              text
              href="https://forms.gle/edB2WoMCptYCe2rGA"
              target="_blank"
              >PRE BETA</v-btn
            >
          </li>
          <li>
            <v-btn
              :ripple="false"
              class="mnu_hd login_btn"
              v-if="isLogin"
              text
              to="/dashboard/shops"
            >
              <v-icon>mdi-view-dashboard-outline</v-icon>
              <span class="text-btn">PANEL DE CONTROL</span>
            </v-btn>
          </li>
          <li>
            <v-btn
              :ripple="false"
              class="mnu_hd"
              :class="{ 'uk-active': 'home_isActive' == this.linkData }"
              text
              to="/"
              >INICIO</v-btn
            >
          </li>
          <li>
            <v-btn
              :ripple="false"
              class="mnu_hd"
              :class="{ 'uk-active': 'price_isActive' == this.linkData }"
              text
              to="/price"
              >PRECIOS</v-btn
            >
          </li>
          <li>
            <v-btn
              :ripple="false"
              class="mnu_hd"
              :class="{ 'uk-active': 'help_isActive' == this.linkData }"
              text
              to="/help"
              >AYUDA</v-btn
            >
          </li>
          <li>
            <v-btn
              :ripple="false"
              class="mnu_hd"
              :class="{ 'uk-active': 'blog_isActive' == this.linkData }"
              text
              href="https://medium.com/lubumas"
              target="_blank"
              >BLOG</v-btn
            >
          </li>
          <li>
            <v-btn
              :ripple="false"
              v-if="isLogin"
              @click="signOut()"
              class="mnu_hd"
              text
            >
              <v-icon>mdi-logout-variant</v-icon>
              <span class="text-btn">SALIR</span>
            </v-btn>
          </li>
        </ul>
      </div>
      <div class="header_right">
        <div class="menu_info small__hide">
          <v-btn
            :ripple="false"
            class="mnu_hd"
            :class="{ 'uk-active': 'home_isActive' == this.linkData }"
            text
            to="/"
            >INICIO</v-btn
          >
          <v-btn
            :ripple="false"
            class="mnu_hd"
            :class="{ 'uk-active': 'price_isActive' == this.linkData }"
            text
            to="/price"
            >PRECIOS</v-btn
          >
          <v-btn
            :ripple="false"
            class="mnu_hd"
            :class="{ 'uk-active': 'help_isActive' == this.linkData }"
            text
            to="/help"
            >AYUDA</v-btn
          >
          <v-btn
            :ripple="false"
            class="mnu_hd"
            :class="{ 'uk-active': 'blog_isActive' == this.linkData }"
            text
            href="https://medium.com/lubumas"
            target="_blank"
            >BLOG</v-btn
          >
        </div>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn color="#000" icon v-if="isLogin" v-on="on">
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <v-list class="custom">
            <v-list-item>
              <v-list-item-title>
                <v-btn class="custom" text to="/dashboard/shops">
                  <v-icon>mdi-view-dashboard-outline</v-icon>
                  <span class="text-btn">DashV2</span>
                </v-btn>
              </v-list-item-title>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>
                <v-btn @click="signOut()" class="custom" text>
                  <v-icon>mdi-logout-variant</v-icon>
                  <span class="text-btn">SALIR</span>
                </v-btn>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <!-- se documento para la beta -->
        <v-btn
          class="register"
          text
          href="https://forms.gle/edB2WoMCptYCe2rGA"
          target="_blank"
          >PRE BETA</v-btn
        >
        <!-- <v-btn text class="small__hide login_btn" to="signin" v-if="!isLogin"
          >INCIAR SESIÓN</v-btn
        > -->
        <!-- <v-btn class="register" text to="signup" v-if="!isLogin"
          >COMENZAR</v-btn
        > -->
      </div>
    </header>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MenuMovil from '@/components/MenuMovil'
export default {
  name: 'Header',
  props: {
    linkData: {
      type: String,
    },
  },
  data() {
    return {
      flat_menu: false,
      viewBlack: false,
    }
  },
  components: {},
  computed: {
    ...mapGetters(['isLogin']),
  },
  methods: {
    activeHamburger() {
      if (this.flat_menu === false) {
        this.flat_menu = true
        this.viewBlack = true
      } else {
        this.flat_menu = false
        this.viewBlack = false
      }
    },
    closeHamburger() {
      this.flat_menu = false
      this.viewBlack = false
    },
    ...mapActions(['signOut']),
  },
}
</script>

<style lang="scss">
@import '../assets/scss/base.scss';
.view_black {
  &.active {
    z-index: 5;
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.5);
  }
}
header.custom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
  background: $bg-header;
  box-shadow: $shadow-2;
  @media #{$tablet-up} {
    min-height: 80px;
    //background: #fff;
  }

  .small__hide {
    display: none !important;
    @media #{$large-up} {
      display: flex !important;
    }
  }

  .header_left {
    padding-left: 10px;
    display: flex;
    align-items: center;
    .small__show {
      display: none;
      @media #{$tablet-down} {
        display: block;
      }
    }
    button.menu_hamburger {
      margin-right: 15px;
      color: #114b5f;
      background: #e4fde1;
      @media #{$large-up} {
        display: none;
      }
    }
    a {
      color: $color-text;
      text-decoration: none;

      &.logo {
        color: transparent;
        background: none !important;
        svg,
        img {
          width: 142px;
          height: 85px;
        }
      }
    }
  }

  .sider-mobile {
    display: block;
    position: fixed;
    top: 0;
    min-height: 100vh;
    z-index: 5;
    width: 100%;
    max-width: 260px;
    background: #e4fde1;
    box-shadow: $shadow-3;
    overflow-y: auto;
    transition-duration: 0.2s;
    transform-style: preserve-3d;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-100%);
    &.active {
      transform: translateX(0);
      display: block;
    }
    .btn__close {
      text-align: right;

      padding: 20px 10px 10px 0;
    }
    ul.menu__left {
      list-style: none;
      padding-right: 24px;
      li {
        margin: 9px 0 9px;
        button.mnu_hd,
        .mnu_hd {
          width: 100%;
          height: 45px;
          justify-content: left;
          &.close__app {
            margin-top: 20px;
            @include pry-btn(
              $primary-site-color,
              $text-site-white,
              0.85rem,
              100px
            );
          }
          &.register {
            margin-left: 0 !important;
            margin-bottom: 20px;
            @include pry-btn(
              $primary-site-color,
              $text-site-white,
              0.85rem,
              100px
            );
            margin-left: 5px;
          }
          &.uk-active {
            font-weight: bold;
            color: $color-primary-light;
          }
        }
      }
    }
  }
  .header_right {
    padding-right: 10px;
    display: flex;
    flex-direction: row;
    .menu_info {
      display: flex;
      flex-direction: row;
      margin-right: 20px;
      .mnu_hd {
        margin-right: 5px;
        @include not-btn($text-site-primary, null, 0.85rem);
        &.uk-active {
          font-weight: bold;
          color: $color-primary-light;
        }
      }
    }

    .register {
      @include pry-btn($primary-site-color, $text-site-white, 0.85rem, 100px);
      margin-left: 5px;
    }
  }
}
.v-list.custom {
  .v-list-item {
    padding: 0 1px;
    .v-btn {
      width: 100%;
      padding-left: 20px;
      padding-right: 20px;
      height: 40px;
      text-align: left;
      justify-content: flex-start;
      span.text-btn {
        margin-left: 5px;
        letter-spacing: 1.1px;
        font-size: 0.9rem;
      }
    }
  }
}
</style>
